import { render, staticRenderFns } from "./Callback.component.vue?vue&type=template&id=5dd92d00&"
import script from "./Callback.component.vue?vue&type=script&lang=ts&"
export * from "./Callback.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports